export default __webpack_public_path__ + "static/media/docs.208639f5.svg";